<template>
  <!-- Flat settings shell (studio-design settings sidebar): docked bordered nav
       on surface-50, no white card. The nav never hides — the minimized mode
       collapses it to an icon rail — so content padding tracks the nav width
       (full `pl-64` vs. rail `pl-16`). -->
  <div class="h-screen bg-surface-50">
    <slot name="nav" />
    <main
      class="h-full duration-300"
      :class="layoutStore.currentLayout === 'default' ? 'pl-64' : 'pl-16'"
    >
      <div
        id="main-content-window"
        class="h-full overflow-auto studio-scrollbar bg-surface-50 duration-500"
      >
        <slot />
      </div>
    </main>
  </div>
</template>

<script setup lang="ts">
import { useLayoutPreferencesStore } from '~/stores/layoutPreferences'

const layoutStore = useLayoutPreferencesStore()
</script>
